export default "__VITE_ASSET__Di7jj9tq__"